const API = process.env.REACT_APP_BACKEND_URL;

export async function fetchAdminPhysicalOrders(params = {}) {
  const url = new URL(`${API}/api/admin/physical-orders`);
  Object.entries(params).forEach(([k, v]) => {
    if (v) url.searchParams.set(k, v);
  });
  const res = await fetch(url.toString(), { credentials: "include" });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.detail || "Could not load physical orders");
  }
  return res.json();
}

export async function fetchAdminPhysicalOrdersSummary() {
  const res = await fetch(`${API}/api/admin/physical-orders/summary`, { credentials: "include" });
  if (!res.ok) throw new Error("Could not load order summary");
  return res.json();
}

export async function fetchAdminPhysicalOrder(orderRef) {
  const res = await fetch(`${API}/api/admin/physical-orders/${encodeURIComponent(orderRef)}`, { credentials: "include" });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.detail || "Could not load order");
  }
  return res.json();
}

export async function updateAdminPhysicalOrderStatus(orderRef, payload) {
  const res = await fetch(`${API}/api/admin/physical-orders/${encodeURIComponent(orderRef)}/status`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.detail || "Could not update order status");
  return data;
}

export function adminPhysicalOrdersCsvUrl() {
  return `${API}/api/admin/physical-orders/export.csv`;
}
